import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "reference"]

  connect() {
    this.scrollToReference()
  }

  handleFrameLoad(event) {
    const target = event.target

    if (target instanceof HTMLElement && target.id?.startsWith("floating_vivians_page_")) {
      this.scrollToElement(target)
    }
  }

  scrollToReference() {
    if (this.hasReferenceTarget) {
      this.scrollToElement(this.referenceTarget)
    }
  }

  scrollToElement(element) {
    requestAnimationFrame(() => {
      if (this.hasContainerTarget && element) {
        const container = this.containerTarget

        const containerTop = container.getBoundingClientRect().top
        const elementTop = element.getBoundingClientRect().top
        const offset = elementTop - containerTop

        container.scrollTo({
          top: container.scrollTop + offset,
          behavior: "smooth"
        })
      }
    })
  }
}
